:root {
  --primary-50: rgb(255, 246, 253);
  --primary-100: rgb(255, 238, 249);
  --primary-150: rgb(254, 230, 246);
  --primary-200: rgb(253, 222, 242);
  --primary-250: rgb(251, 212, 239);
  --primary-300: rgb(249, 201, 235);
  --primary-350: rgb(247, 191, 233);
  --primary-400: rgb(244, 181, 230);
  --primary-450: rgb(239, 150, 218);
  --primary-500: rgb(233, 117, 204);
  --primary-550: rgb(225, 80, 190);
  --primary-600: rgb(217, 18, 174);
  --primary-650: rgb(187, 12, 148);
  --primary-700: rgb(157, 6, 123);
  --primary-750: rgb(129, 2, 100);
  --primary-800: rgb(101, 0, 77);
  --primary-850: rgb(77, 0, 58);
  --primary-900: rgb(55, 0, 40);
  --primary-950: rgb(34, 0, 23);
  --accent-50: rgb(240, 251, 255);
  --accent-100: rgb(228, 246, 255);
  --accent-150: rgb(215, 242, 254);
  --accent-200: rgb(203, 237, 253);
  --accent-250: rgb(188, 234, 254);
  --accent-300: rgb(173, 231, 255);
  --accent-350: rgb(157, 227, 255);
  --accent-400: rgb(140, 224, 255);
  --accent-450: rgb(90, 201, 255);
  --accent-500: rgb(38, 174, 255);
  --accent-550: rgb(0, 143, 255);
  --accent-600: rgb(20, 108, 253);
  --accent-650: rgb(12, 90, 212);
  --accent-700: rgb(5, 72, 173);
  --accent-750: rgb(2, 54, 136);
  --accent-800: rgb(0, 38, 100);
  --accent-850: rgb(0, 26, 77);
  --accent-900: rgb(0, 16, 55);
  --accent-950: rgb(0, 6, 34);
  --grey-50: rgb(250, 250, 250);
  --grey-100: rgb(245, 245, 245);
  --grey-150: rgb(240, 240, 240);
  --grey-200: rgb(235, 235, 235);
  --grey-250: rgb(227, 229, 230);
  --grey-300: rgb(220, 223, 224);
  --grey-350: rgb(212, 217, 219);
  --grey-400: rgb(205, 211, 214);
  --grey-450: rgb(170, 176, 180);
  --grey-500: rgb(136, 143, 146);
  --grey-550: rgb(104, 111, 114);
  --grey-600: rgb(73, 80, 84);
  --grey-650: rgb(63, 69, 73);
  --grey-700: rgb(53, 59, 63);
  --grey-750: rgb(43, 49, 53);
  --grey-800: rgb(34, 39, 43);
  --grey-850: rgb(24, 28, 31);
  --grey-900: rgb(14, 17, 19);
  --grey-950: rgb(5, 7, 9);
}
